<template>
  <el-popover placement="bottom" width="600" trigger="click">
    <div class="commonNotice">
      <el-button
        size="small"
        class="btnReadAll"
        type="success"
        plain
        round
        @click="clearNotice"
        >全部已读</el-button
      >
      <el-button
        size="small"
        type="primary"
        plain
        class="btnGetReadAll"
        round
        @click="showAllRead"
        >查看已读消息</el-button
      >
      <el-tabs v-model="selectTab" class="commonNotice">
        <el-tab-pane :label="taskNoticeTitle" name="taskNoticeTab">
          <TaskNotice
            :taskNoticeSource="taskNoticeSource"
            :taskCount="taskCount"
            @readRemind="readRemind"
            @refershTaskSource="refershTaskSource"
          ></TaskNotice>
        </el-tab-pane>
        <el-tab-pane :label="normalNoticeTitle" name="normalNoticeTab">
          <NormalNotice
            :normalNoticeSource="normalNoticeSource"
            :normalCount="normalCount"
            @readRemind="readRemind"
            @refershNormalSource="refershNormalSource"
          ></NormalNotice>
        </el-tab-pane>
        <el-tab-pane
          :label="otherNoticeTitle"
          name="otherNoticeTab"
        ></el-tab-pane>
      </el-tabs>
    </div>

    <el-badge
      :value="totalCount"
      :hidden="totalCount > 0 ? false : true"
      :max="99"
      slot="reference"
      class="commonNoticeBadge"
    >
      <el-button type="primary" size="mini">
        <i style="font-size:20px" class="el-icon-message-solid"></i>
      </el-button>
    </el-badge>

    <ReadRemindList ref="readRemindList"></ReadRemindList>
  </el-popover>
</template>

<script>
import {
  UpdateTaskMemberFocusDegree,
  GetTaskMemeber,
  GetUnReadRemind,
  ReadRemind,
  ReadAllRemind,
  GetCrisitismById
} from "@/api/modules/basicData/task";
import ReadRemindList from "./ReadRemindList.vue";
import TaskNotice from "./TaskNotice.vue";
import NormalNotice from "./NormalNotice.vue";
import Vue from "vue";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
export default {
  components: {
    ReadRemindList,
    TaskNotice,
    NormalNotice
  },
  data() {
    return {
      totalCount: 0,
      taskCount: 0,
      normalCount: 0,
      otherNoticeTitle: "其他消息",
      selectTab: "taskNoticeTab",
      commentTitle: "",
      taskNoticeSource: [],
      normalNoticeSource: [],
      otherNoticeSource: []
    };
  },
  computed: {
    taskNoticeTitle() {
      return this.taskCount > 0 ? `任务消息(${this.taskCount})` : "任务消息";
    },
    normalNoticeTitle() {
      return this.normalCount > 0
        ? `通知通告(${this.normalCount})`
        : "通知通告";
    }
  },
  methods: {
    showAllRead() {
      this.$refs.readRemindList.dialogVisible = true;
    },
    refershNormalSource(result) {
      this.normalNoticeSource = [...this.normalNoticeSource, ...result.Items];
      this.normalCount = result.TotalItems;
      this.totalCount = this.taskCount + this.normalCount;
      this.selectTab =
        this.taskCount == 0 && this.normalCount > 0
          ? "normalNoticeTab"
          : "taskNoticeTab";
    },
    refershTaskSource(result) {
      this.taskNoticeSource = [...this.taskNoticeSource, ...result.Items];
      this.taskCount = result.TotalItems;
      this.totalCount = this.taskCount + this.normalCount;
      this.selectTab =
        this.taskCount == 0 && this.normalCount > 0
          ? "normalNoticeTab"
          : "taskNoticeTab";
    },
    _getSource() {
      var source = [];
      switch (this.selectTab) {
        case "taskNoticeTab":
        default:
          source = this.taskNoticeSource;
          break;
        case "normalNoticeTab":
          source = this.normalNoticeSource;
          break;
        case "otherNoticeTab":
          source = this.otherNoticeSource;
          break;
      }
      return source;
    },

    clearNotice() {
      // var source = this._getSource();
      // if (source.length === 0) return;
      ReadAllRemind(cookieUser.userId).then(() => {
        this.totalCount = 0;
        this.taskNoticeSource.forEach(o => (o.ISREAD = true));
        this.normalNoticeSource.forEach(o => (o.ISREAD = true));
        this.taskCount = 0;
        this.normalCount = 0;
        // source = [];
      });
    },
    readRemind(item) {
      console.log("readRemind");
      ReadRemind([item.ID]).then(result => {
        if (result > 0) {
          item.ISREAD = true;
          this.totalCount--;
          if (item.RELATIONTYPE == 0) {
            this.taskCount--;
          } else if (item.RELATIONTYPE == 1) {
            this.normalCount--;
          }
        }
      });
    },
    async setAllRead() {
      var source = this._getSource();
      console.log("this.selectTab", this.selectTab);
      console.log("source", source);
      if (source.length === 0) return Promise.resolve(1);
      var idArray = source.filter(o => o.ISREAD == false).map(o => o.ID);
      console.log("setAllRead", idArray);
      await ReadRemind([...idArray]).then(result => {
        if (result > 0) {
          source.forEach(o => (o.ISREAD = true));
          let item = source[0];
          if (item.RELATIONTYPE == 0) {
            this.taskCount = 0;
          } else if (item.RELATIONTYPE == 1) {
            this.normalCount = 0;
          }
        }
      });
    }
  }
};
</script>

<style>
.commonNotice .taskRate .el-rate__icon {
  font-size: 24px !important;
}
.commonNotice .el-tabs__header {
  margin: 0 0 5px !important;
}

.commonNotice .el-scrollbar {
  background: #f4f4f4;
  /*aliceblue;*/
}

.commonNotice .el-card {
  padding: 10px !important;
  margin: 5px !important;
}

.commonNotice .el-card__body {
  margin: 0 !important;
  padding: 0 !important;
}

.commonNoticeBadge .el-badge__content.is-fixed {
  top: 5px !important;
  right: 20px !important;
}</style
><style scoped>
.isRead {
  opacity: 0.4;
}

.commonNotice .noticePanel {
  /* box-shadow: 0 2px 12px 0 rgb(32, 179, 45, 0.4); */
  border: 1px dashed gray;
}

.btnReadAll {
  z-index: 1;
  position: absolute;
  right: 20px;
  top: 10px;
}

.btnGetReadAll {
  z-index: 1;
  position: absolute;
  right: 120px;
  top: 10px;
}
.avatarIcon {
  width: 24px;
  height: 24px;
  margin-top: 10px;
}

.readIcon {
  width: 24px;
  height: 24px;
}

.detailPanel {
  display: flex;
  background: white /*beige*/;
  font-size: 14px;
}

.title {
  font-size: 14px;
  line-height: 26px;
  margin-left: 6px;
  text-align: left;
  box-sizing: border-box;
  cursor: pointer;
}

.nameImg {
  color: #0c9cdb !important;
  margin-right: 5px;
}

.linkName {
  color: #0c9cdb !important;
}

.reply {
  margin-left: 15px;
  color: #0c9cdb !important;
}

.content {
  color: #20b32d;
  margin-left: 6px;
  max-width: 500px;
  overflow: hidden;
  /*超过部分不显示*/
  text-overflow: ellipsis;
  /*超过部分用点点表示*/
  white-space: nowrap;
  /*不换行*/
  text-align: left;
}

.createTime {
  font-size: 10px;
  color: #999;
  margin: 2px 6px;
  float: left;
}
</style>
